import { Outlet } from 'react-router-dom';
import { MainLayout } from '@/components/layout/MainLayout';

export function NirpLayout() {
  return (
    <MainLayout>
      <div className="nirp-theme min-h-full p-6 lg:p-8">
        <Outlet />
      </div>
    </MainLayout>
  );
}
